// extracted by mini-css-extract-plugin
export default {"ribbon":"RibbonMenu_ribbon__nc9vo","ribbonMenu":"RibbonMenu_ribbonMenu__2145H","measurable":"RibbonMenu_measurable__gdBwY","button":"RibbonMenu_button__9B3JT"};